package org.teddapp.project.db.repo

import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import app.cash.sqldelight.coroutines.mapToOneOrNull
import com.tedd.db.Organization
import com.tedd.db.TeddDatabase
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.withContext
import org.teddapp.project.db.newId
import org.teddapp.project.db.nowMillis

class OrganizationRepository(private val db: TeddDatabase) {

    fun observeAll(): Flow<List<Organization>> =
        db.organizationQueries.selectAll().asFlow().mapToList(Dispatchers.Default)

    fun observeById(id: String): Flow<Organization?> =
        db.organizationQueries.selectById(id).asFlow().mapToOneOrNull(Dispatchers.Default)

    suspend fun create(
        name: String,
        color: String,
        icon: String,
        description: String? = null,
        orderIndex: Long = 0,
        id: String = newId("org"),
    ): String = withContext(Dispatchers.Default) {
        val now = nowMillis()
        db.organizationQueries.insert(id, name, description, color, icon, orderIndex, now, now)
        id
    }

    suspend fun update(
        id: String,
        name: String,
        description: String?,
        color: String,
        icon: String,
        orderIndex: Long,
    ) = withContext(Dispatchers.Default) {
        db.organizationQueries.update(name, description, color, icon, orderIndex, nowMillis(), id)
    }

    suspend fun softDelete(id: String) = withContext(Dispatchers.Default) {
        val now = nowMillis()
        db.organizationQueries.softDelete(now, now, id)
    }
}